import { Component } from '@angular/core';

@Component({
  selector: 'app-extension-layout',
  template: `
    <div class="extension-layout">
      <div class="sidebar-container">
        <app-sidebar></app-sidebar>
      </div>
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
      <app-chatwoot></app-chatwoot>
    </div>
  `,
  styles: [`
    .extension-layout {
      min-height: 100vh;
      display: flex;
      background: linear-gradient(180deg, #29262D 0%, #110F13 100%);
    }
    
    .sidebar-container {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      height: 100vh;
      z-index: 100;
    }

    .sidebar-container ::ng-deep app-sidebar {
      height: 100%;
      display: block;
    }
    
    .main-content {
      flex: 1;
      padding: 0 24px;
      overflow-y: auto;
      margin-left: var(--sidebar-width, 204px); /* 根据实际侧边栏宽度调整 */
    }
  `]
})
export class ExtensionLayoutComponent { } 